import { createFileRoute } from "@tanstack/react-router";
import { LegalPageLayout } from "@/components/legal-page-layout";
import { EVENT_RULES } from "@/lib/event-rules";

export const Route = createFileRoute("/yasal/etkinlik-kurallari")({
  head: () => ({
    meta: [
      { title: "Etkinlik Kuralları — JUËN" },
      { name: "description", content: "JUËN etkinliklerine katılım kuralları ve koşulları." },
      { property: "og:title", content: "Etkinlik Kuralları — JUËN" },
      { property: "og:description", content: "JUËN etkinliklerine katılım kuralları ve koşulları." },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <LegalPageLayout title="Etkinlik Kuralları" lastUpdated="02.05.2026">
      <p>
        JUËN etkinliklerine katılan tüm misafirler aşağıdaki kuralları kabul etmiş sayılır.
      </p>
      <ul>
        {EVENT_RULES.map((rule, i) => (
          <li key={i}>{rule}</li>
        ))}
      </ul>
    </LegalPageLayout>
  );
}
